import HttpService from '../HttpService'

const _http = new HttpService()
export default {
  show: (page, options = null) => {
    let _parans = `?page=${page - 1}`;
    if (options) {
      if(options.search) {
        _parans += `&search=${options.search}`;
      }
      if (options.orderByKey) {
        _parans += `&order_by=${options.orderByKey}`
      }
      if (options.ascOrDes) {
        _parans += '&asc'
      }
    }
    return _http.get(`/api/audio-visual/format-type${_parans}`)
  },
  find: (id) => {
    return _http.get(`/api/audio-visual/format-type/${id}`)
  },
  create: (payload) => {
    return _http.post('/api/audio-visual/format-type', payload)
  },
  update: (payload) => {
    return _http.put('/api/audio-visual/format-type', payload)
  },
  delete: (id) => {
    return _http.delete(`/api/audio-visual/format-type/${id}`)
  },
  showProductsAll: () => {
    return _http.get(`/api/audio-visual/format-type/format-type-all`)
  },
}